module.exports = __webpack_public_path__ + "media/images/vertical-dots-1f47f64476a4035b974d35900b403e38.svg";